import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ShareButton from "@/components/ShareButton";
import { useSEO } from "@/hooks/useSEO";
import { scrollToPageTop } from "@/lib/scroll";
import { useI18n } from "@/contexts/I18nContext";
import { ExternalLink } from "lucide-react";

export default function NicaraguaTaxi() {
  const { t } = useI18n();
  React.useEffect(() => { scrollToPageTop(); }, []);
  useSEO({
    title: "Nicaragua Taxi — Trusted transport across Nicaragua | Popoyo.app",
    description:
      "Book a trusted Nicaragua Taxi for airport pickups, city-to-city trips, and full-day excursions across Nicaragua.",
    path: "/nicaragua-taxi",
  });
  return (
    <div className="min-h-screen flex flex-col" data-testid="nicaragua-taxi-page">
      <Header />
      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <section
          className="clay max-w-2xl w-full text-center p-6 sm:p-10 overflow-hidden"
          style={{
            background: "radial-gradient(circle at 50% 0%, #0F2340 0%, #0A1628 65%, #060D1A 100%)",
            color: "#fff",
          }}
        >
          <img
            src="/brand/nicaragua-taxi-logo.png"
            alt="Nicaragua Taxi Services"
            data-testid="nicaragua-taxi-logo"
            className="w-full max-w-md mx-auto mb-2 drop-shadow-[0_18px_30px_rgba(255,200,40,0.18)]"
            style={{ background: "transparent" }}
            loading="eager"
          />
          <p className="text-sm sm:text-base text-white/70 mb-6 px-2">
            {t("nicaragua_taxi_tagline")}
          </p>
          <a
            href="https://www.NicaraguaTaxi.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nicaragua-taxi-link"
            className="inline-flex items-center gap-2 pill px-6 py-3 text-base font-bold text-[#0A1628] hover:scale-[1.03] transition-transform"
            style={{ background: "#FFC700", boxShadow: "0 10px 30px rgba(255,199,0,0.35)" }}
          >
            <ExternalLink className="w-5 h-5" />
            www.NicaraguaTaxi.com
          </a>
          <div className="mt-5 flex justify-center">
            <ShareButton
              variant="ghost"
              path="/nicaragua-taxi"
              title="Nicaragua Taxi — Trusted transport across Nicaragua"
              text="Book trusted taxi service across Nicaragua from Popoyo.app."
              testId="share-nicaragua-taxi-btn"
              className="!text-white/80 hover:!text-white"
            />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
